.container {
  display: flex;
  align-items: center;
  padding: 0 1.25rem;
  gap: 16px;
  width: 100%;
}

.listItemSkeletonGroup {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  padding: 1.5rem 0 1rem 0
}